import React, { Fragment } from 'react';
import TeacherBannerBuy from '../../prelogin/src/components/TeacherBannerBuy';
import PlpvideoPlayer from '../../views/common/PlpvideoPlayer';
import mindmaster from '../../images/icons/mindmaster.png';

export default class InTopBanner extends TeacherBannerBuy {

	render() {
		const prodType = (this.props.prodType) ? this.props.prodType.toLowerCase() + "." : "";

		let country = this.props.country ? this.props.country : null;
		return (
			<section className={this.props.classes + " tchrhead viswanathanbanner"} >
				<div className="container">
					<div class="row">
							{/* <div className="col-lg-3 col-md-4 col-sm-12 leftBannerImg">
							    <span>&#8220;I am very happy to partner with HeyMath! to help children appreciate and enjoy Maths.&#8221;</span>
								<img src={mindmaster} alt="Vishwanathan image in Products" />
								<span className="avail-free-copy">Avail of a free copy of Anand's biography with a HeyMath! subscription</span>
							</div> */}
							<div className="col-lg-12 col-md-12 col-sm-12">
								<div>
									<h1>{this.rb("in." + prodType + "products.heading")}</h1>
									{/*<h1>{this.rb("in."+prodType+"products.heading1")}</h1> */}
								</div>
								<div className="tchrdiv">
									<h2>{this.rb("in." + prodType + "products.subheading")} <br />
										{this.rb("in." + prodType + "products.subheading1")}</h2>
									<Fragment>
										{
											(country) ?
												<PlpvideoPlayer country={country} />
												:
												null
										}
									</Fragment>
								</div>
							</div>
					</div>
				</div>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./src/views/others/InTopBanner.js